import { instanceOf, string } from 'prop-types'

import TileGridSocialCommerce from './tile-grid-social-commerce.js'
import { PLATFORMS } from '../../../../utilities/constants.js'
import getUsername from '../../../../utilities/getUsername.js'
import Settings from '../../../../../models/settings.js'
import Post from '../../../../../models/Post.js'
import setTransparency from '../../../../utilities/setTransparency.js'

export default function GridFeedPostMinimalisticOverlay({ post, feedKey, settings }) {
  const { allowCookies, enableWebAnalytics, postInteractivity } = settings
  const username = getUsername(post)
  const backgroundColor = setTransparency(settings.postBackgroundColor, 'bf')
  const color = settings.postColor

  return (
    <div
      aria-hidden="true"
      className={
        postInteractivity
          ? 'bzfy-c-tilegrid-post__minimalistic-overlay'
          : 'bzfy-c-tilegrid-post__minimalistic-overlay-no-hover'
      }
      style={{
        backgroundColor,
        color,
      }}
    >
      <div className="bzfy-c-tilegrid-post__minimalistic-overlay-content">
        <p>{post.sourceName === PLATFORMS.YOUTUBE ? post.text : username}</p>
        <TileGridSocialCommerce
          allowCookies={allowCookies}
          color={color}
          enableWebAnalytics={enableWebAnalytics}
          feedKey={feedKey}
          post={post}
        />
      </div>
    </div>
  )
}

GridFeedPostMinimalisticOverlay.propTypes = {
  feedKey: string.isRequired,
  post: instanceOf(Post).isRequired,
  settings: instanceOf(Settings).isRequired,
}
